import React from 'react';
import { Box } from '../../../index';

export const HorizontalLine = props => (
  <Box my={2} height={'2px'} bg="neutrals.EclipseE70" {...props} />
);
